import React from "react";
import { useTranslation } from "react-i18next";
import style from "../../order-info/OrderInfoAviation.module.scss";
import CloseIcon from "../../../shared/icons/CloseIcon";
import CommentIcon from "../../../shared/icons/CommentIcon";
import { CURRENCIES } from "../../../../mock";
import { numberToFinanceFormat } from "../../../../utils";
import AppTooltip from "../../../shared/AppTooltip/AppTooltip";
import OrderInfoAviationExpeditorMoreMenu from "./OrderInfoAviationExpeditorMoreMenu";

const OrderInfoAviationExpeditorHeader = ({
  item,
  setIsOpen,
  onOpenChat,
  unreadCount = 0,
  onChangeAmount,
  isSummaryOnly = false,
}) => {
  const { t } = useTranslation();
  if (!item) return null;

  const currency = item.acceptedCurrency || item.currency || "EUR";
  const currencySymbol = CURRENCIES[currency]?.symbol || currency;
  const routeTitle = `${item.cityFromName || ""} - ${item.cityToName || ""}`;
  const subtitleSuffix = item.companyName || "";
  const subtitleMain = `№ ${item.number || ""}${item.referenceNumber ? ` - ${item.referenceNumber}` : ""}`;

  return (
    <div className={style.header}>
      <div className={style.header_left}>
        <CloseIcon
          fill="#6D7885"
          width="24"
          height="24"
          onClick={() => setIsOpen?.(false)}
          style={{ cursor: "pointer", flexShrink: 0 }}
        />
        <div className={style.header_info}>
          <div className={style.header_title}>{routeTitle}</div>
          <div className={style.header_subtitle}>
            <span className={style.header_subtitle_main}>{subtitleMain}</span>
            {subtitleSuffix ? (
              <>
                <span className={style.header_subtitle_sep}>•</span>
                {item.companyName ? (
                  <>
                    <span
                      className={style.header_subtitle_main}
                      data-tooltip-id="aviation-expeditor-header-company-tooltip"
                    >
                      {`${t("orderInfoExpeditor.header.partner")}:`}
                    </span>
                    <span
                      className={style.header_subtitle_expeditor}
                      data-tooltip-id="aviation-expeditor-header-company-tooltip"
                    >
                      {item.companyName}
                    </span>
                    <AppTooltip
                      id="aviation-expeditor-header-company-tooltip"
                      positionStrategy="fixed"
                      delayShow={50}
                    >
                      {item.companyName}
                    </AppTooltip>
                  </>
                ) : (
                  <span className={style.header_subtitle_main}>{subtitleSuffix}</span>
                )}
              </>
            ) : null}
          </div>
        </div>
        {!isSummaryOnly && item?.price ? (
          <div className={style.header_price}>
            {numberToFinanceFormat(item.price, true)} {currencySymbol}
          </div>
        ) : null}
      </div>

      {!isSummaryOnly && (
        <div className={style.header_right}>
          <div className={style.header_badge_wrapper}>
            <button type="button" className={style.header_action_btn} onClick={onOpenChat}>
              <CommentIcon width={20} height={20} fill="#0D3B66" type={2} />
              <span>{t("orderInfo.ordersInfoBasic.chatButton")}</span>
            </button>
            {unreadCount > 0 ? <span className={style.header_badge}>{unreadCount}</span> : null}
          </div>
          <OrderInfoAviationExpeditorMoreMenu item={item} onChangeAmount={onChangeAmount} />
        </div>
      )}
    </div>
  );
};

export default OrderInfoAviationExpeditorHeader;
